import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetDollarSignCircle: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      >
        <path d="M12 2a10 10 0 110 20 10 10 0 010-20m-2 6.5a2.5 2.5 0 012.5-2.5h1a2.5 2.5 0 010 5h-3a2.5 2.5 0 000 5h1a2.5 2.5 0 002.5-2.5M12 5v14" />
      </svg>
    </div>
  );
};

export default WidgetDollarSignCircle;
